


















import { Component, Vue, Prop } from 'vue-property-decorator';
import { Debounced } from '@/utils/debounced';
import { requestGetRequirements } from '@/utils/requirement';

type IRequirementInfo = IRequirement.IResponse.IRequirementInfo;
type IGetRequirement = IRequirement.IRequest.IGetRequirement;

@Component
export default class SearchRequirment extends Vue {
  @Prop({default: () => ({})}) private readonly search!: IGetRequirement;
  private fetching: boolean = false;
  private requirementOptions: IRequirementInfo[] = [];
  private debouncedFetchRequirement: (
    searchVal: string,
  ) => void = new Debounced().use(this.searchRequirement, 1000); // 节流函数

  public searchReqById(requirementId: string) {
    this.fetching = true;
    const params: IGetRequirement = {};
    if (requirementId) {
      params.id = requirementId;
    }
    Object.assign(params, this.search);
    requestGetRequirements(params).then((res) => {
      this.fetching = false;
      this.requirementOptions = res.data;
      this.handleChange(requirementId);
    }).catch((err) => {
      this.fetching = false;
      this.$message.warning(err);
    });
  }
  // 触发搜索需求方法
  private fetchRequirement(searchVal: string) {
    this.debouncedFetchRequirement(searchVal);
  }
  // 请求需求数据
  private searchRequirement(searchVal: string) {
    this.fetching = true;
    const searchTxt = searchVal.trim();
    const params: IGetRequirement = {};
    if (searchTxt) {
      params.title = searchTxt;
    }
    Object.assign(params, this.search);
    requestGetRequirements(params).then((res) => {
      this.fetching = false;
      this.requirementOptions = res.data;
    }).catch((err) => {
      this.fetching = false;
      this.$message.warning(err);
    });
  }
  // 处理选项改变
  private handleChange(value: string) {
    const requirementInfo = this.requirementOptions.find((option) => option.id === value) || null;
    this.$emit('change', requirementInfo);
  }
}
